<template>
  <div id="frame">
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <card :title="title" v-if="tick === 1" id="frame">
      <form>
        <v-text-field
          v-model="date"
          label="Lieferdatum"
          type="date"
        ></v-text-field>
        <v-text-field
          v-model="name"
          :error-messages="nameErrors"
          label="Ihr Name"
          @input="$v.name.$touch()"
          @blur="$v.name.$touch()"
          required
          clearable
          @click:clear="clearName()"
        ></v-text-field>
        <!-- <v-select
          v-model="selectedArtikelkategorie"
          :items="artikelkategorien"
          item-text="name"
          item-value="value"
          label="Artikelkategorie"
          return-object
          attach
          required
        ></v-select> -->
        <v-select
          v-model="selectedArtikelkategorie"
          :items="artikelkategorien"
          item-text="name"
          item-value="value"
          label="Artikelkategorie"
          return-object
          chips
          multiple
          attach
          required
        ></v-select>
        <v-select
          v-model="selectedLieferant"
          :items="lieferanten"
          item-text="name"
          item-value="name"
          label="Lieferant"
          return-object
          attach
          required
        ></v-select>
        <v-text-field
          v-model="temperatur"
          :error-messages="temperaturErrors"
          label="Gemessene Temperatur"
          type="number"
          step="0.1"
          @input="$v.temperatur.$touch()"
          @blur="$v.temperatur.$touch()"
        ></v-text-field>
        <v-list-tile class="form">
          <v-list-tile-action>
            <v-checkbox v-model="eingehalten"></v-checkbox>
          </v-list-tile-action>
          <div @click="eingehalten = !eingehalten" class="pointer">
            Warentemperatur <b>nicht eingehalten</b> <label>(optional)</label>
          </div>
        </v-list-tile>
        <v-text-field
          v-model="bemerkung"
          :label="bemerkungLabel"
          required
          v-on:keyup.enter="nextTick()"
        ></v-text-field>
        <v-divider/>
        <div class="alert alert-danger" id="alert"
            v-if="selectedArtikelkategorie.length === 0 ||
                  selectedLieferant.value === undefined ||
                  name === '' ||
                  temperatur === ''">
          <!-- Erfoglsmeldung -->
          <span> F&uuml;r die Best&auml;tigung fehlt:</span>
          <span v-if="name === ''"><br>Name</span>
          <span v-if="selectedArtikelkategorie.length === 0"><br>Artikelkategorie</span>
          <span v-if="selectedLieferant.value === undefined"><br>Lieferant</span>
          <span v-if="temperatur === ''"><br>Temperatur</span>
        </div>
        <!-- <v-btn @click="submit">submit</v-btn> -->
        <button class="btn btn-lg btn-danger float-left" v-on:click="goBack('cancelAdd')" type="button">abbrechen</button>
        <button class="btn btn-lg btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
      </form>
    </card>

        <card :title="title2" v-if="tick === 2" id="frame">
      <hr>
      <!-- bestätigen --> 
      <div>
        <p class="messstelle">{{title}}</p>
         <table style="width:100%; font-size: 16px">
          <colgroup>
            <col span="1" style="width: 200px;">
            <col span="1">
          </colgroup>
          <tr>
            <td class="angaben">Lieferdatum:</td>
            <td>{{ date | formatDate }}</td>
          </tr>
          <tr>
            <td class="angaben">Ihr Name:</td>
            <td>{{ name }}</td>
          </tr>
          <tr>
            <td class="angaben">Artikelkategorie:</td>
              <td>
                <span v-for="(kategorie, index) of selectedArtikelkategorie" :key="kategorie.value">
                  {{ kategorie.name }}<span v-if="selectedArtikelkategorie.length > 0 && index !== (selectedArtikelkategorie.length - 1)">,</span>
                  </span>
              </td>
          </tr>
          <tr>
            <td class="angaben">Lieferant:</td>
            <td>{{ selectedLieferant.name }}</td>
          </tr>
          <tr>
            <td class="angaben">Temperatur:</td>
            <td v-if="!eingehalten">{{ temperatur }}°C (Warentemperatur wurde eingehalten)</td>
            <td v-else>{{ temperatur }}°C (Warentemperatur wurde <b>nicht</b> eingehalten)</td>
          </tr>
          <tr>
            <td class="angaben">Bemerkung:</td>
            <td>{{ bemerkung }}</td>
          </tr>
        </table>
        <br>
      </div>
      <hr>
      <div v-if="!this.question">
        <p class="messstelle">Weitere TempLogs hinzufügen?</p>
        <button class="btn btn-danger" v-on:click="changeQuestion()" type="button">Nein</button>
        <span class="buttonMargin"></span>
        <button class="btn btn-success" v-on:click="save('newArticle')" type="button">Ja</button>
      </div>
      <div v-if="this.question">
        <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(); changeQuestion()" type="button">abbrechen</button>
        <button class="btn btn-lg btn-success float-right" v-on:click="save()" type="button">bestätigen</button>
      </div>
    </card>
    <div class="alert alert-warning" v-if="showLoadingMessage && tick === 3" id="alert">
      <!-- Loading -->
      <button type="button" aria-hidden="true" class="close"></button>
      <center>
        <span>Eintrag wird erstellt, bitte warten</span>
        <br>
        <v-progress-circular :size="30" :width="7" color="red" indeterminate></v-progress-circular>
      </center>
    </div>
    <div class="alert alert-success" v-if="showSuccessMessage && tick === 3" id="alert">
      <!-- Erfoglsmeldung -->
      <button type="button" aria-hidden="true" class="close"></button>
      <span>
      <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
    </div>
    <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && $online">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Upload dauert länger. ({{ counterFront }} Sekunden)</b>
      </span>
      <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
    </div>
    <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && !$online">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Stellen Sie eine Internetverbindung her. ({{ counterFront }} Sekunden)</b>
      </span>
      <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
    </div>
    <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
      </span>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { helpers } from "vuelidate/lib/validators";
import store from '../../../../store/store';

export const alphaDiacritic = helpers.regex('alphaDiacritic', /^[a-zA-ZÀ-ž ]*$/);

export default {
  mixins: [validationMixin],

  validations: {
      name: { required, alphaDiacritic },
      temperatur: {  required } ,
      date: { required }
  },
  data () {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      // Feste Vorgaben
      title: "Wareneingang - TempLog",
      title2: "Angaben bestätigen",
      // Variablen
      tick: 1,
      showLoadingMessage: false,
      showErrorMessage: false,
      showOnlineMessage: false,
      showSuccessMessage: false,
      routeBack: [],
      counterFront: 0,

      // Formular
      date: "",
      name: "",
      artikelkategorien: [
        { value: 1, name: "Geflügel" },
        { value: 2, name: "Rind" },
        { value: 3, name: "Lamm" },
        { value: 4, name: "Schwein" }
      ],
      lieferanten:[
        { value: 1, name: "REWE" },
        { value: 2, name: "Nagel" },
        { value: 3, name: "Vita Beef" },
        { value: 4, name: "Niegemann" },
      ],
      temperatur: "",
      eingehalten: false,
      bemerkungLabel: "Bemerkung",
      bemerkung: "",
      // Angaben bestaetigen
      question: false,
      selectedArtikelkategorie: [],
      selectedLieferant: {},
    }
  },
  methods: {
    clearName() {
      localStorage.removeItem('name');
      this.name = "";
    },
    clearArtikel() {
      localStorage.removeItem('artikel');
      this.artikel = "";
    },
    clearArtikelnummer() {
      this.artikelnummer = "";
    },
    saveName() {
      const parsed = JSON.stringify(this.name);
      localStorage.setItem('name', parsed);
    },
    disableNotification(){
      this.showErrorMessage = false;
    },
    changeQuestion() {
      this.question = !this.question;
    },
    nextTick() {
      this.$v.$touch();
      if (!this.$v.$invalid && this.selectedLieferant.value !== undefined && this.selectedArtikelkategorie.length > 0) {
        this.tick++;
      }
    },
    cancel(bool) {
      if (bool) {
        this.showSuccessMessage = false;
        this.createToday();
        this.temperatur = "";
        this.bemerkung = "";
        this.eingehalten = false;
        this.selectedLieferant = {};
        this.selectedArtikelkategorie = [];
        this.tick = 1;
      } else {
        this.changeQuestion();
        this.tick = 1;
      }
    },
    goBack(index) {
      if (index < 0) {
        this.$router.go(index);
      } else if (index === 'cancelAdd') {
        this.$router.go(-1);
      }
    },
    formatDate(date){
      var today = new Date(date);
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = dd+ '.' + mm + '.' + yyyy;
      return date;
    },
    createToday() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = yyyy+ '-' + mm + '-' + dd;
      // console.log(date);
      this.date = date;
    },
    save(newArticle) {
      var tmpKategorie = [];
      this.selectedArtikelkategorie.map(kategorie => tmpKategorie.push(kategorie.value));
      let tmpEingehalten;
      this.eingehalten ? tmpEingehalten = 0 : tmpEingehalten = 1;

      let weLog = {
        datum: this.date,
        name: this.name,
        artikelkategorie: JSON.stringify(tmpKategorie),
        lieferant: this.selectedLieferant.value,
        temperatur: this.temperatur,
        eingehalten: tmpEingehalten,
        bemerkung: this.bemerkung,
      };

      if (newArticle === 'newArticle') {
        this.nextTick();
        // console.log(this.tick);
        this.showLoadingMessage = true;
        let counter = 0;
        let internetCounter = 0;
        var interval = setInterval(() => {
          if (this.$online && internetCounter === 0) {
            internetCounter = 1;
            this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/wareingang/temperatur/add', weLog, { headers: {'Authorization': this.auth }})
              .then(function(response) {
                if(response.body.error) {
                  console.log(response.body.error);
                  this.nextTick();
                  this.showLoadingMessage = false;
                  this.showErrorMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.cancel(true), 1500);
                } else {
                  this.showLoadingMessage = false;
                  this.showOnlineMessage = false;
                  this.showSuccessMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.cancel(true), 1500);
                }
            });
          } else {
            this.counterFront++;
            if (counter === 3) {
              this.showOnlineMessage = true;
            }
          }
          counter++;
          if (counter === 10) {
            clearInterval(interval);
          }
        }, 1000);
      } else {
        this.nextTick();
        this.showLoadingMessage = true;
        let counter = 0;
        let internetCounter = 0;
        var interval = setInterval(() => {
          if (this.$online && internetCounter === 0) {
            internetCounter = 1;
            this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/wareingang/temperatur/add', weLog, { headers: {'Authorization': this.auth }})
              .then(function(response) {
                if(response.body.error) {
                  console.log(response.body.error);
                  this.nextTick();
                  this.showLoadingMessage = false;
                  this.showErrorMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.$router.go(-1), 1500);
                } else {
                  this.showLoadingMessage = false;
                  this.showOnlineMessage = false;
                  this.showSuccessMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.$router.push({path: "/qs/servicelisten/wareneingang/temperatur", query: {routeBack: this.routeBack} }), 1500);
                }
            });
          } else {
            this.counterFront++;
            if (counter === 0) {
              this.showOnlineMessage = true;
            }
          }
          counter++;
          if (counter === 10) {
            clearInterval(interval);
          }
        }, 1000);
      }
    },
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.required && errors.push('Bitte geben Sie Ihren Namen ein')
      !this.$v.name.alphaDiacritic && errors.push('Bitte keine Sonderzeichen eingeben')
      return errors
    },
    temperaturErrors () {
      const errors = []
      if (!this.$v.temperatur.$dirty) return errors
      !this.$v.temperatur.required && errors.push('Temperatur muss angegeben werden')
      return errors
    },
    dateErrors () {
      const errors = []
      if (!this.$v.date.$dirty) return errors
      !this.$v.date.required && errors.push('Bitte wählen Sie ein Datum aus')
      return errors
    },
  },
  created: function() {
    this.canModify = !store.state;
    this.createToday();
    this.routeBack = this.$route.query.routeBack;
    if(this.$route.query){
      this.subtitle += " - "+this.$route.query.title;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#frame{
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;

}
.v-messages__message{
   color: rgb(255, 115, 0);
}
.instruction{
    text-align: center;
    font-weight: bold;
}
.pad{
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px ;
}
.messstelle{
  font-weight: bold;
  font-size: large;
}
.angaben{
  font-size: large;
  font-weight: bold;
}

.buttonMargin {
  margin-left: 5vh;
}

.pointer {
  cursor: pointer;
}

.form {
  height: unset;
  padding: 0;
}

.v-list__tile__action, .v-list__tile__avatar {
  min-width: 10px;
}

</style>

